import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  StudentRequest,
  StudentModel,
  RecentPerformanceModel,
  ProblemModel,
  StudentExercisePerformanceModel
} from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorHandlerService } from '../../core/services/error-handler.service';
import { environment } from '../../../environments/environment';

export interface EmbeddedStudentProfile {
  firstName: string;
  lastName: string;
  phone: string;
}

@Injectable({ providedIn: 'root' })
export class StudentService {

  private studentUrl = environment.msStudentApiUrl + 'students/';

  constructor(private http: HttpClient, private errorHandlerService: ErrorHandlerService) {
  }


  updateProfile(student: StudentRequest.Update): Observable<StudentModel> {
    return this.http.patch<StudentModel>(this.studentUrl + 'profile', student).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateEmbeddedProfile(profile: EmbeddedStudentProfile): Observable<StudentModel> {
    return this.http.put<StudentModel>(this.studentUrl + 'profile', profile).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getProfile(): Observable<StudentModel> {
    return this.http.get<StudentModel>(this.studentUrl + 'profile').pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getProblem(problemId: number): Observable<ProblemModel> {
    return this.http.get<ProblemModel>(`${environment.msStudentApiUrl}problems/${problemId}`).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getRecentPerformance(subject: string,
                       onlyIncorrect: boolean,
                       flagged: boolean,
                       offset: number,
                       limit: number): Observable<RecentPerformanceModel> {
    let url = `${environment.msStudentApiUrl}progress/recentPerformance?`;
    url = url + `flagged=${flagged}&onlyIncorrect=${onlyIncorrect}&offset=${offset}&limit=${limit}`;
    if (subject) {
      url = url + `&subject=${subject}`;
    }
    return this.http.get<RecentPerformanceModel>(`${url}`).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getExercisePerformance(): Observable<{ keys: number[]; values: StudentExercisePerformanceModel[] }> {
    return this.http.get<any>(`${environment.msStudentApiUrl}progress/exercisePerformance`).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
